import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { advertiserList, delAdvertiser } from "@/api/Administration/advertiser";
import addAdvertiser from "./components/addAdvertiser";
export default {
  name: "advertiser",
  components: {
    addAdvertiser: addAdvertiser
  },
  data: function data() {
    return {
      tableData: [],
      searchData: {
        page: 1
      },
      total: 0,
      sels: [],
      selsString: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      this.searchData.page = e ? e : this.searchData.page;
      advertiserList(this.searchData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;

          if (!res.data.data.length && _this.searchData.page > 1) {
            _this.getList(_this.searchData.page - 1);
          }
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delAdvertiser({
                  id: id
                }).then(function (res) {
                  _this3.getList();
                });

                _this3.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};